import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";
import TotalRow from './components/TotalRow';

const AdKernelTable = ({ report, total, onSortChange }) => {
    const rows = report.map((row, index) => (<Row {...row} key={index} />));
    console.log(total);
    return (
        <Table bordered responsive style={{ textAlign: 'center', verticalAlign: 'middle' }}>
            <Head onSortChange={onSortChange} />
            <tbody>
                <TotalRow data={total} />
                {rows}
            </tbody>
        </Table>
    )
};

export default AdKernelTable;


// WEBPACK FOOTER //
// ./src/scenes/AdKernel/components/Table/index.js